import script from "./footers.vue?vue&type=script&setup=true&lang=js"
export * from "./footers.vue?vue&type=script&setup=true&lang=js"

import "./footers.vue?vue&type=style&index=0&id=302dd5cf&scoped=true&lang=less"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.5.18_webpack@5.101.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-302dd5cf"]])

export default __exports__